import type { Source } from './answers';

/**
 * De-duplicate sources by URL, keeping the first occurrence.
 * Normalizes URLs by removing trailing slashes for comparison.
 */
export function deduplicateSources(sources: Source[]): Source[] {
  const seen = new Set<string>();
  const unique: Source[] = [];

  for (const source of sources) {
    // Normalize URL for comparison (remove trailing slash, lowercase)
    const normalizedUrl = source.url.replace(/\/$/, '').toLowerCase();

    if (!seen.has(normalizedUrl)) {
      seen.add(normalizedUrl);
      unique.push(source);
    }
  }

  return unique;
}
